"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollingDateGrain = void 0;
var RollingDateGrain;
(function (RollingDateGrain) {
    RollingDateGrain["DAYS"] = "days";
    RollingDateGrain["WEEKS"] = "weeks";
    RollingDateGrain["MONTHS"] = "months";
    RollingDateGrain["QUARTERS"] = "quarters";
    RollingDateGrain["YEARS"] = "years";
})(RollingDateGrain = exports.RollingDateGrain || (exports.RollingDateGrain = {}));
